var newsMasonryContainer = jQuery('.ajankohtaista-grid');
var newsMasonryList = null;
if(newsMasonryContainer){
  newsMasonryContainer.append('<img id="loading-news" src="/wp-content/themes/brang/assets/images/loading.gif" alt="Ladataan..." title="Ladataan...">')
  var jqxhr = jQuery.get( "/wp-json/wp/v2/ajankohtaista?_embed", function( data ) {
  })
  .done(function( data ) {
    newsMasonryList = data;
    var newsMasonryContainer = jQuery('.ajankohtaista-grid');

    var $grid = jQuery('.ajankohtaista-grid').masonry({
      columnWidth: '.grid-item',
      itemSelector: '.grid-item',
      percentPosition: true,
      gutter: 20,
    });

    jQuery.each(newsMasonryList, function(idx, obj){
      // jQuery.each( obj.acf.kategoria, function( i, val ) {
      //   category_string = category_string.concat(val, ' ');
      var articleImage;
      // });
      try {
         articleImage = obj._embedded['wp:featuredmedia']['0'].source_url
      } catch(err) {
        articleImage = '/wp-content/themes/brang/assets/images/brang-placeholder.png'
      }

      var articleDate = new Date(obj.date);
      var articleDateString = articleDate.getDate() + '.' + (articleDate.getMonth() + 1) + '.' + articleDate.getFullYear();

      var $item = jQuery('<div class="grid-item"><img src="'+articleImage+'"><div class="grid-item-inner"><h2>'+obj.title.rendered+'</h2><p class="article-date">'+articleDateString+'</p>'+obj.excerpt.rendered+'<div class="custom-button-container"><a href="'+obj.link+'">Lue lisää</a></div></div</div>')
      $grid.append($item).masonry( 'appended', $item );
      $grid.imagesLoaded().progress( function() {
        $grid.masonry('layout');
      });

      jQuery('#loading-news').hide();

    });

  })
  .fail(function() {
    console.log('error');
  })
  .always(function() {
  });
}
